<template>
    <div class="bodyPage">
        <v-data-table
            :headers="tableHeaders"
            :items="clients || []"
            class="elevation-4 table"
            :loading="loading"
            :loading-text="labels.textLoading"
            v-resize="onResize"
            :search="search"
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>{{'Clientes' | translate('Clientes')}}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="labels.buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        :max-width="editDialogWidth"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="btn1" 
                                v-bind="attrs"
                                v-on="on"
                                dark
                                small
                                @click="openNewClient()"
                            >
                                <v-icon small>
                                    mdi-plus
                                </v-icon>
                                <span>{{ 'Novo' | translate('Clientes') }}</span>
                            </v-btn>
                        </template>
                        <v-form ref="form">
                            <v-card :loading="loading">
                                <v-card-title>
                                    <span class="headline">{{ 'Cadastro de Cliente' | translate('Clientes')}} </span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="registrationDialog">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.NOME"
                                                    :label="labels.nome"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row style="height: 3em; margin-top:0;">
                                            <v-col cols="12" style="padding-top:4px;">
                                                <v-radio-group
                                                    v-model="personType"
                                                    row
                                                >
                                                    <v-radio
                                                        :label="labels.fisica"
                                                        value="F"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="labels.juridica"
                                                        value="J"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.CPF"
                                                    :label="labels.cpf"
                                                    v-mask="'###.###.###-##'"
                                                    :rules="personType == 'F'? [rules.cpf] : []"
                                                    :disabled="personType != 'F'"
                                                    counter="14"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.CNPJ"
                                                    :label="labels.cnpj"
                                                    v-mask="'##.###.###/####-##'"
                                                    :rules="personType == 'J'? [rules.cnpj] : []"
                                                    :disabled="personType != 'J'"
                                                    counter="18"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.TELEFONE"
                                                    :label="labels.telefone"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.CELULAR"
                                                    :label="labels.celular"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.PAIS"
                                                    :label="labels.pais"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.ESTADO"
                                                    :label="labels.estado"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.CEP"
                                                    :label="labels.cep"
                                                    v-mask="'#####-###'"
                                                    :rules="[rules.required]"
                                                    required
                                                    counter="9"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.CIDADE"
                                                    :label="labels.cidade"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.BAIRRO"
                                                    :label="labels.bairro"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.RUA"
                                                    :label="labels.rua"
                                                    :rules="[rules.required]"
                                                    required                                                    
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.NUMERO"
                                                    :label="labels.numero"
                                                    :rules="[rules.required]"
                                                    required                                                    
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.COMPLEMENTO"
                                                    :label="labels.complemento"
                                                    :rules="[rules.required]"
                                                    required                                                    
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="fileColumn">
                                                <label for="assetsFieldHandle" class="dragAndDropFile" @drop="onFileChange" @dragover="dragover" @dragleave="dragleave">
                                                    <input id="assetsFieldHandle" class="inputFile" type="file" @change="onFileChange" ref="file" accept=".pdf,.jpg,.jpeg,.png">
                                                    <div class="boxItems">
                                                        <img :src="getImage()" width="140" />
                                                        <span>
                                                            {{'Clique, ou arraste seu arquivo aqui' | translate('Clientes')}} 
                                                        </span>
                                                    </div>
                                                </label>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="white--text btn1" 
                                    small
                                    color="black"
                                    @click="close"
                                >
                                    {{'Cancel' | translate('Clientes')}}
                                </v-btn>
                                <v-btn 
                                    class="white--text btn1" 
                                    small
                                    color="black"
                                    @click="save"
                                    :disabled="validateForm()"
                                >
                                    {{'Save' | translate('Clientes')}}
                                </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.imagem`]="{ item }">
                <v-avatar
                    class="avatar"
                    @click="floatingMenuCollapsed = !floatingMenuCollapsed"
                    size="40px"
                >
                    <img
                        alt="Avatar"
                        width="40"
                        height="40"
                        :src="getAvatarimage(item)"
                    >
                </v-avatar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="editItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="deleteItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="fit-content">
            <v-card>
                <v-card-title>
                    {{'Você realmente deseja excluir este cliente? ' | translate('Clientes')}} {{editedItem.NOME}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="deleteCalcel"
                    >
                        {{'Cancelar' | translate('Clientes')}}
                    </v-btn>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="deleteConfirm"
                    >
                        {{'Sim' | translate('Clientes')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import translate from '../../../../src/plugins/translate'
import loadClients from '../../../../src/app/cliente/loadAll'
import uploadFile from '../../../../src/app/file/upload'
import updateClient from '../../../../src/app/cliente/updateClient'
import addClient from '../../../../src/app/cliente/addClient'
import deleteClient from '../../../../src/app/cliente/deleteClient'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')

export default {
    name: 'Clientes',
    components: {},
    data() {
        return {
            valid: false,
            loading: false,
            search: null,
            dialog: false,
            newClient: false,
            image: null,
            personType: null,
            baseUrl: process.env.VUE_APP_API_URL,
            dialogDelete: false,
            imageTime: new Date().getTime(),
            editDialogWidth: '800px',
            defaultImage: require('../../../../src/assets/user.png'),
            labels: {
                buscar: translate('Buscar', 'Clientes'),
                nome: translate('Nome', 'Clientes'),
                telefone: translate('Telefone', 'Clientes'),
                celular: translate('Celular', 'Clientes'),
                pais: translate('Pais', 'Clientes'),
                estado: translate('Estado', 'Clientes'),
                cidade: translate('Cidade', 'Clientes'),
                bairro: translate('Bairro', 'Clientes'),
                rua: translate('Rua', 'Clientes'),
                numero: translate('Número', 'Clientes'),
                complemento: translate('Complemento', 'Clientes'),
                fisica: translate('Fisica', 'Clientes'),
                juridica: translate('Juridica', 'Clientes'),
                cpf: 'CPF',
                cnpj: 'CNPJ',
                cep: 'CEP',
                textLoading: translate('Um momento...', 'Clientes'),
                textNoData: translate('Nenhum registro localizado', 'Clientes')
            },
            editedItem: {},
            clients: [],
            windowSize: {x:0, y:0},
            file_upload: require('../../../../src/assets/system/file_upload.png'),
            tableHeaders: [
                { text: '', value: 'imagem', width: '10%', sortable: false },
                { text: translate('Descrição', 'Clientes'), value: 'NOME', width: '80%' },
                { text: translate('Ações', 'Clientes'), value: 'actions', sortable: false, width: '10%', align:'center' }
            ],
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Clientes'),
                cpf: (val) => {
                    const patern = /[0-9]{11}/
                    if(!val) return translate('Deve ser preenchido!','Clientes')
                    val = val.replace(/[-.]/g, '')
                    return patern.test(val) || translate('CPF invalido!','Clientes')
                },
                cnpj: (val) => {
                    const patern = /[0-9]{14}/
                    if(!val) return translate('Deve ser preenchido!','Clientes')
                    val = val.replace(/[-.^/]/g, '')
                    return patern.test(val) || translate('CNPJ invalido!','Clientes')
                }
            },
        }
    },
    methods: {
        validate () {
            this.$refs.form.validate()
        },
        resetValidation () {
            this.$refs.form.resetValidation()
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if(this.windowSize.x < 800) this.editDialogWidth = '600px'
            else if(this.windowSize.x < 1025) this.editDialogWidth = '860px'
            else this.editDialogWidth = '1000px'
        },
        async getAllClients() {
            this.clients = []
            this.loading = true
            await loadClients().then(function(response){
                let self = this
                this.imageTime = new Date().getTime()
                setTimeout(function(){
                    self.clients = response.data
                    self.loading = false
                }, 100)
            }.bind(this))
        },
        close () {
            this.image = null
            this.editedItem = {}
            this.dialog = false
            this.resetValidation()
        },
        dragover(event) {
            event.preventDefault();
            event.currentTarget.style.backgroundColor="#ededed"
        },
        dragleave(event) {
            event.currentTarget.style.backgroundColor="transparent"
        },
        onFileChange(event) {
            event.preventDefault();
            var files = event.target.files || event.dataTransfer.files
            if (!files || !files.length) return
            this.image = files[0]
            this.criateShowImage(this.image)
            this.dragleave(event)
        },
        criateShowImage(file) {
            var reader = new FileReader()
            var self = this
            self.loading = true
            reader.onload = (event) => {
                self.$nextTick(() => {
                    self.editedItem.IMAGEM_PERFIL = event.target.result
                    self.loading = false
                })
            }
            reader.readAsDataURL(file);
        },
        async save() {
            this.loading = true
            if(this.editedItem.CEP) this.editedItem.CEP = this.editedItem.CEP.replace(/[-.]/g, '')
            if(this.personType === 'F') this.editedItem.CPF = this.editedItem.CPF.replace(/[-.]/g, '')
            if(this.personType === 'J') this.editedItem.CNPJ = this.editedItem.CNPJ.replace(/[-.^/]/g, '')
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            await this.editedItem.ID ? updateClient(this.editedItem).then(this.uploadImage).catch(this.refresh) : addClient(this.editedItem).then(this.uploadImage).catch(this.refresh)
        },
        async uploadImage(response) {
            var self = this
            if(this.image){
                var formData = new FormData()
                formData.append('image', self.image, self.image.name)
                await uploadFile({directory:'img/pessoas', personId:response.data.PESSOA_ID}, formData)
                    .then(function(){
                        self.close()
                        self.image = null
                        self.loading = false
                    }.bind(self))
                    .catch(function(){
                        self.loading = false
                    }.bind(self))
            } else {
                self.close()
                self.loading = false
            }
            await this.getAllClients()
        },
        editItem (item) {
            if(item.CPF) this.personType = 'F'
            if(item.CNPJ) this.personType = 'J'
            this.editedItem = Object.assign({}, item)
            let self = this
            setTimeout(function(){
                self.dialog = true
            },10)
        },
        validateForm() {
            if(!this.editedItem.NOME || !this.editedItem.NOME.length)  return true
            if(!this.editedItem.TELEFONE || !this.editedItem.TELEFONE.length)  return true 
            if(!this.editedItem.CELULAR || !this.editedItem.CELULAR.length)  return true 
            if(!this.editedItem.PAIS || !this.editedItem.PAIS.length)  return true 
            if(!this.editedItem.ESTADO || !this.editedItem.ESTADO.length)  return true 
            if(!this.editedItem.CIDADE || !this.editedItem.CIDADE.length)  return true 
            if(!this.editedItem.BAIRRO || !this.editedItem.BAIRRO.length)  return true 
            if(!this.editedItem.CEP || !this.editedItem.CEP.length)  return true 
            if(!this.editedItem.RUA || !this.editedItem.RUA.length) return true
            if(!this.editedItem.NUMERO || !this.editedItem.NUMERO.length) return true
            if(!this.editedItem.COMPLEMENTO || !this.editedItem.COMPLEMENTO.length) return true
            let validatePersonType = this.getpersonTypeVerify()
            if(!validatePersonType || !validatePersonType.length) return true
            return false
        },
        getpersonTypeVerify() {
            if(!this.personType) return false
            if(this.personType === 'F') return this.editedItem.CPF
            if(this.personType === 'J') return this.editedItem.CNPJ
        },
        openNewClient(){
            this.newClient = !this.newClient
            this.editedItem = {}
            this.resetValidation()
            this.personType = null
        },
        deleteItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteCalcel () {
            this.editedItem = {}
            this.dialogDelete = false
        },
        async deleteConfirm () {
            this.dialogDelete = false
            this.loading = true
            await deleteClient(this.editedItem)
                .then(function(){
                    this.loading = false
                    this.getAllClients()
                }.bind(this))
                .catch(this.refresh)
        },
        getImage() {
            if(this.editedItem.IMAGEM_PERFIL){
                return this.editedItem.IMAGEM_PERFIL.includes('base64') ? this.editedItem.IMAGEM_PERFIL : this.baseUrl + this.editedItem.IMAGEM_PERFIL + '?t=' + this.imageTime
            }
            else return this.file_upload
        },
        getAvatarimage(item) {
            return item.IMAGEM_PERFIL ? this.baseUrl + item.IMAGEM_PERFIL + '?t=' + this.imageTime : this.defaultImage
        },
        refresh(){
            this.loading = false
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        this.onResize()
        this.loading = true
        await this.getAllClients()
    },

}
</script>
<style scoped>
.btn1{
    border-radius: 6px;
    text-transform: none;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.bodyPage{
    padding-top:0.5%;
}
.table{
    width: 90%;
}
.fileColumn{
    display: flex;
    align-items: center;
    justify-content: center;
}

.dragAndDropFile{
    border: 2px solid #afafaf;
    border-radius: 20px;
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-style: dashed;
}
.dragAndDropFile:hover{
    cursor: pointer;
    background-color: #ededed;
}
.boxItems{
    padding: 1em;
    display: grid;
    justify-items: center;
}
.inputFile{
    overflow: hidden;
    display: none;
}
.registrationDialog {
    overflow-x: auto;
    overflow-y: hidden;
    max-height: 600px;
}
.registrationDialog::-webkit-scrollbar {
    width: 8px;
}

.registrationDialog::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.registrationDialog::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}

.registrationDialog > .container > .row{
    height: 6em ;
}
.actionButtons{
    max-width: 40% !important
}
@media only screen and (max-width: 600px) {
    table{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .editDialog{
        padding-left: 6em;
    }
    .table{
        width: 100%;
    }
}
</style>